import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCepMask]'
})
export class CepMaskDirective {

  constructor(
    private model: NgControl
  ) {}

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  @HostListener('keydown.backspace') onKeyDownBackspace() {
    this.modelValue(true);
  }

  private modelValue(backspace?: boolean) {
    if (this.model) {
      var model: any = this.model;
      if(model.viewModel) {
        if (typeof model.viewModel === 'number') {
          model.viewModel = model.viewModel.toString();
        }
        this.inputChange(model.viewModel, backspace);
      }
    }
  }

  private inputChange(model: any, backspace?: any) {
    if (model) {
      var newVal = model.replace(/\D/g, '');

      if (backspace) {
        if (newVal.length === 2) {
          newVal = newVal.substring(0, newVal.length - 1);
        }
      }

      if (newVal.length == 0) {
        newVal = '';
      } else {
        newVal = newVal.replace(/(\d{5})(\d{0})/, "$1-$2");
      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/cep-mask.directive.ts
 **/